// @ts-check
// "Exportar" da barra de view: baixa do servidor o CSV da lista com os filtros, a ordenação e as colunas visíveis
// da view atual (inclusive o rascunho ainda não salvo), como o usuário está vendo.
import { html } from 'htm/preact';
import { useState } from 'preact/hooks';
import { Icon } from '../../ui/icon.js';
import { downloadRecordsCsv } from '../../data/dashboards.js';
import { downloadBlob, toFileName } from '../../lib/csv.js';
import { enqueueSnackbar, showErrorSnackbar, showSuccessSnackbar } from '../../ui/snackbar.js';
import { getViewQuery } from './view-state.js';
import { getVisibleFieldNames } from '../command-menu/selection-actions.js';
import { t, translateMetadataLabel } from '../../i18n/index.js';

/**
 * Baixa o CSV da view como ela está na tela; usado pelo botão, pelo menu de comandos e pelo botão fixado.
 * @param {import('../../lib/field-metadata.js').ObjectMetadata} objectMetadata @param {import('../../data/metadata-store.js').View} view
 */
export async function exportViewRecords(objectMetadata, view) {
  const { filter, orderBy, drilldown } = getViewQuery(view);
  const { blob, fileName, headers } = await downloadRecordsCsv(objectMetadata.namePlural, {
    filter,
    orderBy: orderBy.filter((item) => item.field !== 'position'),
    fields: getVisibleFieldNames(view),
    viewId: view.id,
    drilldown,
  });
  downloadBlob(blob, fileName ?? toFileName(`${translateMetadataLabel(objectMetadata.labelPlural)} ${translateMetadataLabel(view.name)}`));
  if (headers['x-export-truncated'] === 'true' || headers['x-export-truncated'] === '1') {
    // o servidor para em 50.000 linhas; avisar evita que a planilha pareça completa
    enqueueSnackbar({ message: t('export.truncated', { count: Number(headers['x-total-count'] ?? 0) }), variant: 'warning' });
  } else {
    showSuccessSnackbar(t('export.done'));
  }
}

/**
 * @param {{ objectMetadata: import('../../lib/field-metadata.js').ObjectMetadata, view: import('../../data/metadata-store.js').View }} props
 */
export function ExportRecordsButton({ objectMetadata, view }) {
  const [isExporting, setIsExporting] = useState(false);
  const exportRecords = async () => {
    setIsExporting(true);
    try {
      await exportViewRecords(objectMetadata, view);
    } catch (error) {
      showErrorSnackbar(error);
    } finally {
      setIsExporting(false);
    }
  };
  return html`<button type="button" class="header-dropdown-button" disabled=${isExporting} aria-busy=${isExporting ? 'true' : undefined}
    title=${t('export.tooltip')} onClick=${exportRecords}>
    <${Icon} name="IconDownload" size=${14} />
    <span class="export-records-label">${isExporting ? t('export.exporting') : t('export.button')}</span>
  </button>`;
}
